export const urls = {
	sprintsForIds: '/rest/jpo/1.0/sprint/get',
	sprintSearch: (query: string) => `/rest/jpo/1.0/sprint/search?query=${query}&maxResults=10`,
} as const;
